import { filter } from "rxjs/operators";
import { CommandeService } from "../_services/commande.service";
import { Component, OnInit } from "@angular/core";
import { Commande } from "../models/Commande.model";
import Swal from "sweetalert2";
import { ClientService } from './../_services/Client.service';
@Component({
  selector: "app-gestion-commande",
  templateUrl: "./gestion-commande.component.html",
  styleUrls: ["./gestion-commande.component.css"],
})
export class GestionCommandeComponent implements OnInit {
  commandesNow: Commande[];
  commandesPast: Commande[];
  //statistique: StatistiqueModel[];
  commandesFuture: Commande[];
  commandesByDays: Commande[];
  commande: Commande;
  nbrecommandeEncours = 0;
  nbrClient: Number;
  montantcommande = 0;
  montantvente = 0;
  nbrecommandePasser = 0;
  client_idTab = [];
  showSpinnerMail: boolean = false;
  etat;
  p: number = 1;
  filterItems: any;
  TotalVenteBoutique = 0;
  NbrCommandeALivrer = 0;
  NbrTotalCommande = 0;
  AllCommande: Commande[] = [];
  items = [
    { libelle: "1", jour: 1 },
    { libelle: "2" },
    { libelle: "3" },
    { libelle: "4" },
    { libelle: "5" },
    { libelle: "6" },
    { libelle: "7" },
    { libelle: "8" },
    { libelle: "9" },
    { libelle: "10" },
  ];
  selected; //= { id: 1, name: 'Tel' };
  constructor(private commandeservice: CommandeService,
              private clientService: ClientService) {}


  ngOnInit() {
    this.GetNombreClient();
    this.commande = new Commande();
    this.LoadCommandeNow();
    this.LoadCommandePast();
    this.LoadCommandeFuture();
    this.GetStattistques();

  }
GetStattistques(){
  this.commandeservice.getData().subscribe((data: Commande[]) => {
    this.AllCommande = data;
    console.log("Allcommande",this.AllCommande);
    this.TotalVenteBoutique = 0;
    this.NbrCommandeALivrer = 0;
    this.NbrTotalCommande = 0;
    for(let c of this.AllCommande){
      this.TotalVenteBoutique += c.montant;
      if(c.etat == 'Terminé'){
        this.NbrCommandeALivrer += 1;
      }
    }
    this.NbrTotalCommande = this.AllCommande.length;
    console.log("TotalVenteBoutique",this.TotalVenteBoutique);
  });
}
  getValues() {
    console.log(this.selected);
    console.log(this.selected.libelle);
    this.LoadCommandeByDays();

  }


  GetNombreClient() {
    this.nbrClient = 0;
    this.clientService.getNombreClient().subscribe((nbr: Number) => {
      this.nbrClient = nbr;
    });
  }

  LoadCommandeNow() {
    this.nbrecommandeEncours = 0;
    this.nbrecommandePasser = 0;
    this.nbrecommandeEncours = 0;
    this.commandeservice.getCommandeDateNow().subscribe((data: Commande[]) => {
      for (let a of data) {
        a.cocher = false;
      }
      this.commandesNow = data;
      console.log(this.commandesNow);
    });
  }

  LoadCommandePast() {
    this.commandeservice.getCommandeDatePast().subscribe((data: Commande[]) => {
      for (let a of data) {
        a.cocher = false;
      }
      this.commandesPast = data;
    });
  }

  LoadCommandeFuture() {
    this.commandeservice
      .getCommandeDateFuture()
      .subscribe((data: Commande[]) => {
        for (let a of data) {
          a.cocher = false;
        }
        this.commandesFuture = data;
        this.filterItems = this.commandesFuture;
      });
  }

  LoadCommandeByDays() {
    this.commandeservice
      .GetDelaiCommandeByDay(Number(this.selected.libelle))
      .subscribe((data: Commande[]) => {
        this.commandesByDays = data;
      });
  }

  GetPhoneNumber(param: any) {
    param.record.cocher = !param.record.cocher;
    this.client_idTab.push(param.record);
    /*if (param.record.cocher == true) {
      this.data.push(param.record);
      console.log(this.data);
    }*/
    //for(a of )
    /*if (param.record.cocher == true){
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].telephone === param.record.telephone ) {
          this.data.splice(i, 1);
          this.data.push(param.record);
        }/*else {
          this.data.push(param.record);
        }
      }

    }*/
    //console.log(this.data);

    //if()
    //}
    //if (param.record.etat == 'Terminé') {
    //this.clientPhone_number.push(param.record.telephone);
    //console.log(this.clientPhone_number);
    //}
  }
  /*  SendEmail(){
    //console.log(this.client_idTab);
    this.showSpinnerMail = true;
    this.commande.clientId_number.length = 0;
    this.commandesNow.filter((a) => {
      console.log(a);
      if (a.cocher == true) {
        //a.cocher = false;
        this.commande.clientId_number.push(a.id);
      }
      //this.commandesNow = data;
      console.log(this.commande.clientId_number);
    });
    this.commandeservice.SendMail(this.commande).subscribe(
      (res) => {
        console.log(res);
        this.commande.message = "";
        this.showSpinnerMail = false;
        this.AlertSendMailSucces();
        //window.history.back();
      },
      (err) => {
        console.log(err);
        this.showSpinnerMail = false;
        this.AlertMail();


      }
    );


  }

  SendEmailPast() {
    //console.log(this.client_idTab);
    this.showSpinnerMail = true;
    this.commande.clientId_number.length = 0;
    this.commandesPast.filter((a) => {
      console.log(a);
      if (a.cocher == true) {
        //a.cocher = false;
        this.commande.clientId_number.push(a.id);
      }
      //this.commandesNow = data;
      console.log(this.commandesPast);
      console.log(this.commande.clientId_number);
    });
    this.commandeservice.SendMail(this.commande).subscribe(
      (res) => {
        console.log(res);
        this.commande.message = "";
        this.showSpinnerMail = false;
        this.AlertSendMailSucces();
        //window.history.back();
      },
      (err) => {
        console.log(err);
        this.showSpinnerMail = false;
        this.AlertMail();

      }
    );


  }

  SendEmailFuture() {
    //console.log(this.client_idTab);
    this.showSpinnerMail = true;
    this.commande.clientId_number.length = 0;
    this.commandesFuture.filter((a) => {
      console.log(a);
      if (a.cocher == true) {
        //a.cocher = false;
        this.commande.clientId_number.push(a.id);
      }
      //this.commandesNow = data;
      console.log(this.commandesFuture);
      console.log(this.commande.clientId_number);
    });
    this.commandeservice.SendMail(this.commande).subscribe(
      (res) => {
        console.log(res);
        this.commande.message = "";
        this.showSpinnerMail = false;
        this.AlertSendMailSucces();
        //window.history.back();
      },
      (err) => {
        console.log(err);
        this.showSpinnerMail = false;
        this.AlertMail();

      }
    );


  } */
  FilterDay() {
    this.filterItems = this.commandesFuture.filter((item) => {
      return item.dayAlert.indexOf(this.selected.libelle) > -1;
    });
  }

  UpadteEtat(id, data) {
    return this.commandeservice.updateEtatCommande(id).subscribe(
      (res) => {
        console.log(res);
        this.AlertUpdate();
        this.LoadCommandeNow();
        this.LoadCommandePast();
        this.LoadCommandeFuture();
        this.GetStattistques();
      },
      (err) => {
        console.log("Update non effectué");
      }
    );
  }

  UpadteEtatLivre(id, data) {
    return this.commandeservice.updateEtatCommandeLivre(id).subscribe(
      (res) => {
        console.log(res);
        if(res == 1){
          Swal.fire({
            title: 'Attention cette commande n\'est encore complètement régler par le client pour être livré.',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok!',
          });
        }else{
          this.AlertUpdate();
          this.LoadCommandeNow();
          this.LoadCommandePast();
          this.LoadCommandeFuture();
          this.GetStattistques();
        }

      },
      (err) => {
        console.log("Update non effectué");

      }
    );
  }

  AlertUpdate() {
    Swal.fire({ title: "Etat commande modifié avec succès" }).then((result) => {
      if (result.value) {
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }

  AlertMail() {
    Swal.fire({
      title:
        "Mail non envoyer veuillez réessayer ou vérifier votre connexion internet !!!",
    }).then((result) => {
      if (result.value) {
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }

  AlertSendMailSucces() {
    Swal.fire({ title: "Mail envoyée avec succès !!!" }).then((result) => {
      if (result.value) {
        // handle Confirm button click
        // result.value will contain `true` or the input value
      } else {
        // handle dismissals
        // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
      }
    });
  }
}
